import { IBaseDrivingStyle } from "../../resourceManagement/driving-styles-manager/driving-styles.interfaces";

export enum Colour {
    None,
    Blue,
    Red,
    Yellow,
    Orange,
    Green,
    Purple,
    Black,
    Grey
}

export interface IDrivingStyleMetricScore extends IBaseDrivingStyle {
    Colour: Colour;
    RawValue: number;
    Score: number;
}
